import React from 'react';
import styles from './ProgressLogo.module.scss';
import happy from '../../assets/happy.gif';
import happy2 from '../../assets/happy2.png';
import { useTranslation } from 'react-i18next';

export const ProgressLogo = ({ isRenderingDone, text }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.progressContainer}>
      <div className={styles.logoLoaderContainer} style={{ backgroundColor: '#7C43AA' }}>
        <div className={styles.logoLoader}>
          <img src={happy2} className={styles.logoWink} alt={t('logo_chooser.header')} />
          {isRenderingDone && <img src={happy} className={styles.logoWink} alt={t('logo_chooser.header')} />}
        </div>
      </div>
      <p className={styles.loaderText}>{text}</p>
    </div>
  );
};
